import type { IUserJSON } from 'external-api-types';
import type { History } from 'history';
import type { ToastProps } from '../components/common/Toast/Toast';
import type { CoreUser } from '../types/User';
import type { GlobalActions } from './../actions/global';

export type UrlParams = { [k: string]: string };

export interface State {
    user: IUserJSON | null;
    coreUser: CoreUser | null;
    history: History;
    urlParams: UrlParams;
    pageTitle: string;
    toasts: ToastProps[];
}

const getDefaultState = (): State => ({
    /**
     * The authenticated Create user.
     */
    user: null,

    /**
     * The authenticated Core user.
     */
    coreUser: null,

    /**
     * Browser history instance
     */
    history: null as $TSFixMe,

    /**
     * Current url params
     */
    urlParams: Object.fromEntries(new URLSearchParams(window.location.search)),

    /**
     * Current app page title
     */
    pageTitle: '',

    /**
     * All toast notifications
     */
    toasts: []
});

const globalReducer = (state = getDefaultState(), action: GlobalActions): State => {
    switch (action.type) {
        case 'INIT_GLOBAL_STORE': {
            return {
                ...state,
                history: action.data.history
            };
        }

        case 'SET_AUTHENTICATED_USER': {
            return {
                ...state,
                user: action.data.user || null,
                coreUser: action.data.coreUser || null
            };
        }

        case 'SET_URL_PARAMS': {
            return {
                ...state,
                urlParams: action.data.urlParams || {}
            };
        }

        case 'SET_PAGE_TITLE': {
            return {
                ...state,
                pageTitle: action.data.pageTitle
            };
        }

        case 'ADD_TOAST': {
            return {
                ...state,
                toasts: [action.data, ...state.toasts]
            };
        }

        case 'EDIT_TOAST': {
            const toasts = [...state.toasts];
            const index = toasts.findIndex((t) => t.id === action.data.id);
            toasts[index] = action.data;
            return {
                ...state,
                toasts
            };
        }

        case 'REMOVE_TOAST': {
            const toasts = state.toasts.slice();
            const index = toasts.indexOf(action.data);
            if (index >= 0) {
                toasts.splice(index, 1);
            }
            return {
                ...state,
                toasts
            };
        }

        case 'REMOVE_TOAST_BY_ID': {
            const toasts = state.toasts.slice();
            const index = toasts.findIndex((t) => t.id === action.data.id);
            if (index >= 0) {
                toasts.splice(index, 1);
            }
            return {
                ...state,
                toasts
            };
        }

        case 'REMOVE_ALL_TOASTS': {
            return {
                ...state,
                toasts: []
            };
        }

        default: {
            return state;
        }
    }
};

export default globalReducer;

export const localStorePaths = [];
